import { ThemeService } from '@/app/core/services/theme/theme.service';
import {Component, computed, EventEmitter, inject, Input, Output} from '@angular/core';


@Component({
  selector: 'app-confirm-delete-dialog',
  standalone: true,
  imports: [],
  templateUrl: './confirm-delete-dialog.html',
  styleUrl: './confirm-delete-dialog.scss'
})
export class ConfirmDeleteDialog {
  private themeService = inject(ThemeService);

  protected themeContent = this.themeService.themeContent;
  protected clientsComponent = computed(() => this.themeContent()?.clientsComponent);

  @Input() message!: string;
  @Output() confirmar = new EventEmitter<void>();
  @Output() cancelar = new EventEmitter<void>();

  onConfirmar() {
    this.confirmar.emit();
  }

  onCancelar() {
    this.cancelar.emit();
  }
}
